module.exports = __webpack_public_path__ + "img/failure.27a1e00b.svg";